<template>
    <section class="page">
        <main>
            <div class="header">
                <strong>智能哨兵网站后台管理</strong>
            </div>
            <div class="pagemain">
                <div class="tblbox">
                    <a-table size="small" :dataSource="manageList" :columns="columns"
                        :scroll="{ y: 'calc(100vh - 280px)' }" pagination="false" 
                        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">
                        <template #bodyCell="{ column, record, index }">
                            <template v-if="column.key === 'sn'">
                                {{ index + 1 }}
                            </template>
                            <template v-if="column.key === 'title'">
                                {{ record.title }}
                            </template>
                            <template v-if="column.key === 'operation'">
                                
                                    <a-space>
                                        <a href="javascript:;" @click.prevent="openHref(record.title)">进入</a>
                                    </a-space>
                            </template>
                        </template></a-table>
                </div>
            </div>
        </main>
    </section>
</template>

<script setup>
import '@wangeditor/editor/dist/css/style.css';

const columns= [
  {
    title: '序号',
    dataIndex: 'sn',
    key: 'sn',
    width: 50,
    align: 'center',
  },
  {
    title: '管理页面名称',
    dataIndex: 'title',
    key: 'title',
     width: 300,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    width: 150,
  }
  ];

  const manageList=[
    {
        title:"资源中心",
    },
     {
        title:"新闻动态",
    },
  ];

  const openHref =(title)=>{

    if(title=="新闻动态"){
         window.open(`/newContent`, '_blank');
    }
    if(title=="资源中心"){
         window.open(`/resource`, '_blank');
    }
  };
</script>